import React from 'react';
import { TableRow } from '@insurancemenu/imenu-components-lib';
import { TableHeadingPropsType } from '@insurancemenu/imenu-components-lib/dist/types';
import { GroupSortBy, SortOrder } from 'types/groupService';
import { observer } from 'mobx-react-lite';
import { useGroupDashboardPageStore } from 'store/pages/groups-dashboard/pageStore';
import { TableHeaderStyled, TableHeadingStyled } from './styles';

interface TableHeadingObj extends Omit<TableHeadingPropsType, 'onSortCallback' | 'children'> {
  title: string;
}

interface Props {
  headings: TableHeadingObj[];
}

const DashboardTableHeader: React.FC<Props> = observer(({ headings }) => {
  const { setSortBy, setSortOrder } = useGroupDashboardPageStore();

  function onTableSort(sortKey: string, sortOrder: 'ASC' | 'DESC'): void {
    setSortBy(sortKey as GroupSortBy);
    setSortOrder(sortOrder as SortOrder);
  }

  return (
    <TableHeaderStyled>
      <TableRow>
        {headings.map((headingObj) => (
          <TableHeadingStyled
            {...headingObj}
            onSortCallback={headingObj.sorting ? onTableSort : undefined}
            key={headingObj.title}
          >
            {headingObj.title}
          </TableHeadingStyled>
        ))}
      </TableRow>
    </TableHeaderStyled>
  );
});

export default DashboardTableHeader;
